/**
 * 서버 리포트 수치의 표시 헬퍼.
 *
 * 리포트는 JSON 이라 데이터가 부족한 항목이 `null` 로 온다 (알고리즘에서는 NaN 이다).
 * 전역 `isFinite` 는 `isFinite(null) === true` 라 이 값을 통과시키므로 쓰지 않는다.
 */

/** 값이 없을 때 화면에 쓰는 문자열 */
export const NO_VALUE = '-';

const isNumber = (value: number | null | undefined): value is number =>
  Number.isFinite(value);

/** 소수 자릿수를 맞춘 표시값. 값이 없으면 '-' */
export const formatNumber = (
  value: number | null | undefined,
  digits: number = 0
): string => (isNumber(value) ? value.toFixed(digits) : NO_VALUE);

/** 반올림한 정수 표시값. 값이 없으면 '-' */
export const formatRounded = (value: number | null | undefined): string =>
  isNumber(value) ? String(Math.round(value)) : NO_VALUE;

/** 비율(0~1)을 퍼센트 문자열로. 값이 없으면 '-' */
export const formatPercent = (
  value: number | null | undefined,
  digits: number = 0
): string => (isNumber(value) ? `${(value * 100).toFixed(digits)}%` : NO_VALUE);

/** 게이지 너비처럼 숫자가 반드시 필요한 자리. 값이 없으면 fallback 으로 접는다 */
export const numberOr = (
  value: number | null | undefined,
  fallback: number = 0
): number => (isNumber(value) ? value : fallback);
